import { Button, type ButtonProps } from '@mantine/core';
import React, { useMemo } from 'react';

const ButtonLink = (
  props: React.PropsWithChildren<{ wrap: boolean } & ButtonProps>,
) => {
  const { children, wrap = false, ...buttonProps } = props;

  return (
    <Button
      size={'md'}
      variant="subtle"
      p={0}
      h="auto"
      fw={400}
      component="a"
      target="_blank"
      {...buttonProps}
      sx={{
        span: {
          whiteSpace: 'pre-wrap',
        },
        '*[class*="-Button-inner"]': {
          alignItems: 'flex-start',
        },
        '&:hover': {
          backgroundColor: 'inherit',
        },
        '*[class*="-Button-label"]': {
          ...(wrap ? { overflowWrap: 'anywhere' } : {}),
        },
      }}
    >
      {children}
    </Button>
  );
};

export default ButtonLink;
